// extracted by mini-css-extract-plugin
module.exports = {"targetPeriod":"TargetDetailPeriod__targetPeriod--3YItp","paymentDate":"TargetDetailPeriod__paymentDate--zWJmW"};